import ActionType from "../ActionType";

export const setEquipmentMasterFilter = (data: object) => ({
  type: ActionType.SET_EQUIPMENT_MASTER_FILTER,
  data,
});
export const setSearch = (data: string) => ({
  type: ActionType.SET_SEARCH,
  data,
});
export const updateEquipmentMaster = (data: boolean) => ({
  type: ActionType.UPDATE_EQUIPMENT_MASTER,
  data,
});
